/*
 * Copyright (c) Nexign, JSC, 2021-2022.
 */
/**
 * Inquiry close modal container component
 *
 * @author Julia Ignatieva
 * @version 1.19.0
 * @since 1.15.0
 */

import { ICommonTranslation } from '../../../../modules/internationalization/types';
import { IPageInquiryInfoTranslation } from '../../../../modules/internationalization/types/pages/inquiryInfo';
import { IModalRenderProps } from '../../../../modules/modal/types/modalTypes';
import InquiryCloseModalForm from './InquiryCloseModalForm';
import {
    CloseInquiryContainerStyled,
    CloseInquiryHeaderStyled,
    CloseInquiryTitleStyled,
    CloseInquiryInfoStyled,
} from './styled/InquiryCloseStyled';

export interface IInquiryInfoCloseModal extends Pick<IModalRenderProps, 'onCloseModal'> {
    inquiryId: string;
    translation: IPageInquiryInfoTranslation;
    translationCommon: ICommonTranslation;
}

const InquiryCloseModal = (props: IInquiryInfoCloseModal) => {
    return (
        <CloseInquiryContainerStyled data-component={'modal-popup'} data-name={'create-inquiry'}>
            <CloseInquiryHeaderStyled>
                <CloseInquiryTitleStyled>
                    {props.translation.closeModal.title}
                </CloseInquiryTitleStyled>
                <CloseInquiryInfoStyled>
                    {props.translation.closeModal.message}
                </CloseInquiryInfoStyled>
            </CloseInquiryHeaderStyled>
            <InquiryCloseModalForm
                {...props}
            />
        </CloseInquiryContainerStyled>
    );
};

export default InquiryCloseModal;
